<template>
  <el-container class="accessories-container">
    <el-aside width="220px" class="aside-menu">
      <div class="header-top">车型列表</div>
      <ul>
        <li
          v-for="item in vehicleModelList"
          :key="item.id"
          class="vehicleModel"
          :class="{ activeVehicle: activeListItem == item.id }"
          @click="getVehicleAccessory(item.id)"
        >
          {{ item.vehicleModel }}
        </li>
      </ul>
    </el-aside>
    <el-container>
      <el-main class="main-container">
        <div class="header-top">
          <div>配件列表</div>
          <div class="el-icon-plus" @click="addAccessories"></div>
          <el-button type="primary" @click="TemplateDownload"
            >模板下载</el-button
          >
          <el-button type="primary" @click="clickBatchImport"
            >批量导入</el-button
          >
          <el-button type="danger" @click="allDelete">批量删除</el-button>
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          size="mini"
          stripe
          height="560px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="24"
            align="center"
            style="padding: 0"
          ></el-table-column>
          <!-- <el-table-column width="40px"></el-table-column> -->
          <el-table-column
            type="index"
            label="序号"
            width="100px"
          ></el-table-column>
          <el-table-column
            label="配件名称"
            prop="accessoryName"
            min-width="120px"
          ></el-table-column>
          <el-table-column
            label="规格/代号/件号"
            prop="specification"
            min-width="160px"
          ></el-table-column>
          <el-table-column
            label="主要参数"
            prop="majorParameter"
            min-width="200px"
          ></el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="{ row }">
              <el-button type="text" @click="editAccessories(row)"
                >编辑</el-button
              >
              <el-button type="text" @click="deleteAccessories(row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
    <el-dialog :title="editTitle" :visible.sync="editDialog">
      <el-form
        ref="vehicleEdit"
        :model="queryForm"
        label-position="left"
        label-width="140px"
        size="mini"
        inline
        :rules="accessoriesRule"
      >
        <el-form-item label="车型选择" prop="vehicleModelId">
          <el-select
            v-model.trim="queryForm.vehicleModelId"
            placeholder="请选择车型"
          >
            <el-option
              v-for="item in vehicleModelList"
              :key="item.id"
              :label="item.vehicleModel"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="配件名称" prop="accessoryName">
          <el-input
            v-model.trim="queryForm.accessoryName"
            placeholder="请输入配件名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="规格/代号/件号" prop="specification">
          <el-input
            v-model.trim="queryForm.specification"
            placeholder="请输入规格/代号/件号"
          ></el-input>
        </el-form-item>
        <el-form-item label="主要参数" prop="majorParameter">
          <el-input
            v-model.trim="queryForm.majorParameter"
            placeholder="请输入主要参数"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="edit-footer">
        <el-button type="primary" @click="uploadSaveOrUpdate()">确认</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
    <!-- 批量导入 -->
    <el-dialog
      title="配件批量导入"
      :visible.sync="importVisible"
      class="mini-dialog accessories"
    >
      <el-form
        :rules="modelRules"
        ref="importForm"
        :model="importForm"
        size="mini"
        :inline="true"
      >
        <el-form-item prop="modelId" label="车辆型号">
          <el-select v-model="importForm.modelId" placeholder="请选择车型">
            <el-option
              v-for="item in vehicleModelList"
              :key="item.id"
              :label="item.vehicleModel"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="upload-box" label="文件名">
          <el-upload
            class="upload-demo"
            ref="upload"
            :with-credentials="true"
            :multiple="false"
            :limit="1"
            accept=".xls, .xlsx"
            :data="myData()"
            :file-list="fileList"
            :on-change="addFile"
            :action="uploadUrl()"
            :http-request="uploadSectionFile"
            :auto-upload="false"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="importVisible = false">取 消</el-button>
        <el-button type="primary" @click="importCommit">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name: "AccessoriesManagement",
  data() {
    return {
      tableData: [],
      tableVal: [],
      vehicleModelList: [],
      activeListItem: false,
      editDialog: false,
      queryForm: {
        id: null,
        vehicleModelId: null,
        accessoryName: "",
        specification: "",
        majorParameter: "",
      },
      editFlag: null,
      editTitle: "",
      vehicleId: null,
      accessoriesRule: {
        accessoryName: [
          { required: true, trigger: "blur", message: "请输入配件名称" },
        ],
        specification: [
          {
            required: true,
            trigger: "blur",
            message: "请输入规格/代号/件号",
          },
        ],
      },
      importVisible: false,
      modelRules: {
        modelId: [
          {
            required: true,
            trigger: "change",
            message: "请选择车辆型号",
          },
        ],
      },
      importForm: {
        modelId: "",
      },
      fileList: [],
    };
  },
  created() {
    this.getVehicleModel();
  },
  methods: {
    // 模板下载
    TemplateDownload() {
      this.$confirm("确定下载该模板吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        window.location.href = "/api/error/recording/templateAccessory";
      });
    },
    // 批量导入-start-
    clickBatchImport() {
      this.$resetForm(this, "importForm");
      this.fileList = [];
      this.importVisible = true;
      console.log(this.vehicleId);
      this.importForm.modelId = this.vehicleId ? this.vehicleId : null;
    },
    myData() {
      return {
        id: this.importForm.modelId,
      };
    },
    addFile(file, fileList) {
      this.fileList = fileList;
      //限制上传文件为5M
      this.fileSizeIsSatisfy = file.size < 5 * 1024 * 1024 ? true : false;
      this.extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      console.log(file.type);
    },
    uploadUrl() {
      return "/api/error/recording/importAccessory";
    },
    async uploadSectionFile(parm) {
      let _this = this;
      let fileObj = parm.file;
      // FormData 对象
      let form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("vehicleModelId", JSON.stringify(_this.importForm.modelId));
      let { data: res } = await _this.$axios.post("/api/error/recording/importAccessory", form);
      if (res.code == 1) {
        _this.$message.success("导入成功");
        _this.importVisible = false;
        //导入成功后清空upload
        _this.$refs.upload.clearFiles();
        _this.fileList = [];
        _this.getVehicleAccessory(_this.importForm.modelId);
      } else {
        _this.$refs.upload.clearFiles();
        _this.fileList = [];
        _this.$message.warning(res.msg);
      }
    },
    async importCommit() {
      this.$refs.importForm.validate((valid) => {
        if (valid) {
          if (this.fileList.length <= 0) {
            this.$message.warning("请至少上传一个文件！");
            return;
          }
          if (this.extension !== "xlsx" && this.extension !== "xls") {
            this.$message.warning("上传失败！请上传excel表格文件！");
            this.$refs.upload.clearFiles();
            this.fileList = [];
            return;
          }
          if (!this.fileSizeIsSatisfy) {
            this.$message.warning("上传失败！文件大小超过5M！");
            this.$refs.upload.clearFiles();
            this.fileList = [];
            return;
          }
          this.$refs.upload.submit();
        }
      });
    },
    // 批量导入-end-
    // 确认/修改配件信息
    uploadSaveOrUpdate() {
      this.$refs.vehicleEdit.validate(async (valid) => {
        if (valid) {
          let obj = {};
          obj.id = this.queryForm.id;
          obj.accessoryName = this.queryForm.accessoryName;
          obj.majorParameter = this.queryForm.majorParameter;
          obj.specification = this.queryForm.specification;
          obj.vehicleModelId = this.queryForm.vehicleModelId;
          console.log(valid);
          if (this.editFlag) {
            // 编辑提交
            let { data: res } = await this.$axios.put(
              "/api/error/recording/updateAccessory",
              obj
            );
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.editDialog = false;
              this.getVehicleAccessory(this.vehicleId);
            } else {
              this.$message.warning(res.msg);
            }
          } else {
            // 新增提交
            this.vehicleId = this.queryForm.vehicleModelId;
            console.log(this.queryForm.vehicleModelId);
            let { data: res } = await this.$axios.post(
              "/api/error/recording/insertAccessory",
              obj
            );
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.editDialog = false;
              this.getVehicleAccessory(this.vehicleId);
            } else {
              this.$message.warning(res.msg);
            }
          }
        }
      });
    },
    cancel() {
      console.log("cancel");
      // 清除校验
      this.$refs.vehicleEdit.clearValidate();
      // 关闭弹框
      this.editDialog = false;
    },
    addAccessories() {
      this.editFlag = false;
      this.editDialog = true;
      this.editTitle = "新增配件";
      // 清空数据
      this.queryForm = {};
    },
    editAccessories(row) {
      this.editFlag = true;
      this.editDialog = true;
      this.editTitle = "编辑配件";
      console.log(row);
      // 清空数据
      this.queryForm = this.$options.data().queryForm;
      // 深拷贝【一层是深拷贝】
      this.queryForm = Object.assign({}, { ...row });
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val;
    },
    allDelete() {
      // 多选删除
      let ids = this.$getIds(this.tableVal);
      if (!ids) {
        return;
      }
      this.$confirm("确定删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 删除接口
          let { data: res } = await this.$axios.delete(
            "/api/error/recording/deleteAccessory",
            {
              data: ids,
            }
          );
          if (res.code == 1) {
            this.$message({ type: "success", message: "删除成功!" });
            let totalPage = Math.ceil((this.total - 1) / 10);
            let currentPage =
              this.currentPage > totalPage ? totalPage : this.currentPage;
            this.currentPage = currentPage < 1 ? 1 : currentPage;
            this.getVehicleAccessory(this.vehicleId);
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    deleteAccessories(row) {
      let ids = [];
      ids = [row.id];
      this.$confirm("确定删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 删除接口
          let { data: res } = await this.$axios.delete(
            "/api/error/recording/deleteAccessory",
            {
              data: ids,
            }
          );
          if (res.code == 1) {
            this.$message({ type: "success", message: "删除成功!" });
            this.getVehicleAccessory(row.vehicleModelId);
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getVehicleModel() {
      let { data: res } = await this.$axios.get(
        "/api/error/recording/selectVehicleModel"
      );
      if (res.code == 1) {
        this.vehicleModelList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    async getVehicleAccessory(vehicleId) {
      // 选中车型
      this.activeListItem = vehicleId;
      this.vehicleId = vehicleId;
      let { data: res } = await this.$axios.get(
        "/api/error/recording/selectAccessory?vehicleModelId=" + vehicleId
      );
      if (res.code == 1) {
        this.tableData = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.accessories-container {
  height: calc(100% - 40px);
  margin: 20px;
  background: #f8f8f8;
  .aside-menu {
    padding: 20px;
    .header-top {
      height: 38px;
      line-height: 38px;
      text-align: center;
      color: #333;
      border-bottom: 1px solid #333;
    }
    ul {
      margin-top: 10px;
    }
    .vehicleModel {
      height: 38px;
      line-height: 38px;
      text-align: center;
      cursor: pointer;
      &:hover {
        background: #00ff00;
      }
    }
    .activeVehicle {
      background: #00ff00;
    }
  }
  .main-container {
    .header-top {
      display: flex;
      align-items: center;
      height: 38px;
      padding: 0 20px;
      color: #333;
      border-bottom: 1px solid #333;
      margin-bottom: 50px;
      .el-icon-plus {
        margin: 0 30px;
        font-size: 18px;
        font-weight: 600;
      }
      [type="button"] {
        margin-right: 10px;
      }
    }
  }
  .edit-footer {
    margin: 30px 20px 0 0;
    text-align: right;
  }

  /deep/ .el-main {
    background: #fff;
  }
  /deep/ .el-dialog {
    width: 600px;
    .el-dialog__header {
      text-align: center;
    }
    .el-dialog__body {
      min-height: 300px;
      text-align: center;
      .el-form .el-input__inner {
        width: 220px;
      }
    }
  }
  .accessories {
    /deep/ .el-dialog__body {
      min-height: 104px;
      text-align: left !important;
      .el-input__inner {
        width: 100% !important;
      }
    }
  }
  .upload-box /deep/ .el-form-item__label {
    padding-left: 11px;
    position: relative;
  }
  .upload-box /deep/ .el-form-item__label::before {
    content: "*";
    color: #f56c6c;
    position: absolute;
    left: 0px;
    top: 1px;
  }
}
</style>
